import { render } from "./upsert.vue?vue&type=template&id=8728d35c&scoped=true"
import script from "./upsert.vue?vue&type=script&lang=js"
export * from "./upsert.vue?vue&type=script&lang=js"

import "./upsert.vue?vue&type=style&index=0&id=8728d35c&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8728d35c"]])

export default __exports__